// wmda埋点上报
import { QUEUE } from '../types';
import { Queue, loadJS, isSussKey, isNumberStr, getContext, isString, getUid } from '../helpers';
import platforms from './platforms';
import getPageType from '../vueInstance/getPageType';
import { APP_CONFIG, wmdaSdkUrl } from './utils/constant';
import { splitParams } from './utils';

import { InitParams, ReportParams, WMDALOG, Options, ExtJson } from './types';

export default class Log implements WMDALOG {
    // wmda埋点初始化是否完成
    initStatus: boolean = false;
    //全局初始化参数
    initParams: InitParams = {};
    // wmda埋点队列
    queue: QUEUE = new Queue();
    constructor(params: InitParams) {
        this.init(params);
    }
    // wmda埋点初始化
    init(params: InitParams = {}) {
        try {
            if (getContext() !== 'pc' && getContext() !== 'm' && getContext() !== 'harmony') {
                throw new Error('wmda埋点不支持当前所属端');
            }

            // // wuba、ganji端检测，bizLine参数必传
            // if(isContext === 'wuba' || isContext === 'ganji'){
            //   if(!params.bizLine){
            //     throw new Error('bizLine必填！')
            //   }
            // }

            // 初始化公共参数
            this.initParams = params;

            // 初始化wmda配置
            this.initWmdaConfig(params);

            // 初始化成功回调
            const initSuccess = () => {
                console.log('【weblog-wmda】wmda埋点初始化完成');
                this.initStatus = true;
                this.queueReport();
            };

            // 检查埋点sdk是否加载。TODO 后续支持其他端时，这里需要判断只有pc、m端需要加载
            if (!window.WMDA_REPORT) {
                loadJS(wmdaSdkUrl.web, initSuccess);
            } else {
                initSuccess();
            }
        } catch (error) {
            console.error(`【weblog-wmda】初始化异常：${error}`);
        }
    }

    // 更新初始化参数
    updateInitParams(params: InitParams) {
        this.initParams = {
            ...this.initParams,
            ...params
        };
    }

    initWmdaConfig(options: Options) {
        const {
            appid,
            key,
            project_id,
            API_TYPE,
            page_extra,
            user_extra,
            SPA_HASH,
            cate_id,
            channel,
            getUserId,
            getDeviceId
        } = options;
        const defaultApp = APP_CONFIG[getContext()];

        window.WMDA_SDK_CONFIG = {
            api_v: 1, // api版本
            sdk_v: 0.2, // sdk版本
            mode: 'report', // 默认置为report，即全埋点模式
            appid: appid || defaultApp.id, // 应用id，在伏羲(WMDA)平台新建项目后自动生成
            key: key || defaultApp.key, // key,同上
            project_id: project_id || '29317198571852', // 项目id HRG_招聘默认项目https://wmda.58corp.com/#/checks/track-management/event-list?projectid=29317198571852
            API_TYPE: API_TYPE || '', // 传递API_TYPE并且值为test时sdk会向测试环境上报埋点数据，上线时需要关闭（不配置此key或者值为空）！！！
            page_extra: page_extra || [], // 页面属性扩展字段，只在上报pv时携带，注意每个维度的key需和WMDA用户行为分析平台上配置的对应页面自定义维度的key一致，按需填写
            user_extra: user_extra || [], // 用户属性拓展字段，所有上报中（自动，手动，pv） 都会携带，注意每个维度的key需和WMDA用户行为分析平台上配置的对应页面自定义维度的key一致，按需填写
            SPA_HASH: SPA_HASH || true, // 单页应用必选
            cate_id: cate_id || '', // 业务线id,按需填写
            channel: channel || '', // 渠道,按需填写
            getUserId: getUserId || getUid // 用户id,按需填写
        };
        // 设备id，用以区分设备，按需填写, 如果没有，注意注释该函数
        if (getDeviceId) {
            window.WMDA_SDK_CONFIG.getDeviceId = getDeviceId;
        }

        if (!window.WMDA_SDK_CONFIG.appid || !window.WMDA_SDK_CONFIG.key) {
            throw new Error('初始化配置错误, appid is required, 请前往伏羲平台(https://wmda.58corp.com/)查询所属应用');
        }
    }

    // 清除队列: 环境成功之后，发送队列中的数据
    queueReport() {
        // 防止密集型请求，导致请求被拦截
        const timer = setInterval(() => {
            if (this.queue.length() > 0) {
                const reportData: ReportParams = this.queue.dequeue();
                this.report(reportData);
            } else {
                clearInterval(timer);
            }
        }, 20);
    }

    // 数据上报
    report(params: ReportParams) {
        try {
            // getPageType：vue router meta 中传递的log参数获取
            const routerParams = getPageType();

            // 合并 params、routerParams、this.initParams
            const reportParams: ReportParams = splitParams({
                ...this.initParams,
                ...routerParams,
                ...params
            });

            platforms[getContext()](reportParams);
        } catch (error) {
            console.error(`【weblog-wmda】埋点上报异常：${error}`);
        }
    }

    /**
     * 点击事件上报
     * @param actionType
     * @param params
     * @returns
     */
    clickLog(actionType: string, params: ExtJson) {
        try {
            if (getContext() !== 'pc' && getContext() !== 'm' && getContext() !== 'harmony') {
                throw new Error(`${getContext()}端不支持上报wmda埋点`);
            }

            // actionType 必填，且是字符串或数字字符串，并且满足正则要求
            if (!actionType || !isSussKey(actionType)) {
                throw new Error('actionType必填！');
            }

            /**
             * 上报参数
             * 如果actionType是数字，则认为是纯wmda埋点直接上报，该参数表示eventId，真实actionType和pageType都在params中
             * 如果actionType是字符串，则认为是埋点双写场景，eventId为-1，actionType为字符串
             */
            const reportParams: ReportParams = {
                eventId: isNumberStr(actionType) ? actionType : '-1',
                actionType: actionType,
                ...params
            };

            // 根据初始化状态决定直接上报还是加入队列
            this.initStatus ? this.report(reportParams) : this.queue.add(reportParams);
        } catch (error) {
            console.error(`【weblog-wmda】${error}`);
        }
    }
}
